// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrap-wYJoCI{align-items:center;gap:10px;display:inline-flex}.clickable-cybxoz{cursor:pointer}.icon-z4D4wc{flex-shrink:0;display:block}.text-i0iMG7{color:var(--abr-text-primary,#1f1f1f);font-size:15px;font-weight:600;line-height:1.2}.text-i0iMG7 small{color:var(--abr-text-muted,#8c8c8c);font-size:10px;font-weight:400;display:block}.text-white-CgfGwG,.text-white-CgfGwG small{color:#fff}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `wrap-wYJoCI`,
	"clickable": `clickable-cybxoz`,
	"icon": `icon-z4D4wc`,
	"text": `text-i0iMG7`,
	"text-white": `text-white-CgfGwG`,
	"textWhite": `text-white-CgfGwG`
};
export default ___CSS_LOADER_EXPORT___;
